<template>
  <svg :style="{transform: active ? 'rotate(180deg)': 'none', opacity: active ? '1' : '.4'}" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">

      <path fill-rule="evenodd" clip-rule="evenodd" d="M7 5C5.89543 5 5 5.89543 5 7V23C5 24.1046 5.89543 25 7 25H23C24.1046 25 25 24.1046 25 23V7C25 5.89543 24.1046 5 23 5H7ZM11.7143 7.85714C11.162 7.85714 10.7143 8.30486 10.7143 8.85714V21.1429C10.7143 21.6951 11.162 22.1429 11.7143 22.1429H12.5714C13.1237 22.1429 13.5714 21.6951 13.5714 21.1429V8.85714C13.5714 8.30486 13.1237 7.85714 12.5714 7.85714H11.7143Z" fill="#00527F"/>
  </svg>

</template>

<script>
  export default {
    name: 'navigartorIcon',
    props: {
      active: {
        type: Boolean
      }
    }
  }
</script>
